import {removeParamFromUrl} from "./utils/urlHelpers";
import {resetPricePerNight} from "./utils/filterUtils";

const woodBackground = document.querySelector(".has-small-wood-background");
const pageHeaderContent = document.querySelector(".page-header-content");

if (woodBackground && pageHeaderContent) {
    measureHeader();

    $(window).on("load", function () {
        measureHeader();
    });
}

function measureHeader() {
    if(!pageHeaderContent) {
        return;
    }

    let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    let height;

    if (width >= 992) {
        height = pageHeaderContent.offsetHeight + 120;
    } else {
        height = pageHeaderContent.offsetHeight + 50;
    }

    woodBackground.style.backgroundSize = "100% " + height + "px";
}

$(function () {
    // Detect scroll header
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.topbar').outerHeight();

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();

            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        navbarHeight = $('.topbar').outerHeight();
        var st = $(window).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('header').addClass('nav-up').css("top", -navbarHeight);
        } else {
            if (st > 100) {
                $('header').addClass('nav-up').css("top", -navbarHeight);
            } else {
                $('header').removeClass('nav-up').css("top", -1);
            }
        }

        lastScrollTop = st;
    }

    $(".menu-trigger").click(function (e) {
        e.preventDefault();

        $(".navbar").toggleClass("active");
        $(this).toggleClass("opened");
    });

    $('li.dropdown').hover(function () {
            $(this).find('.dropdown-menu').show();
        },
        function () {
            $(this).find('.dropdown-menu').hide();
        });


    $(".language-switcher .dropdown-toggle").click(function () {
        setTimeout(function () {
            let navbar = $(".navbar");
            navbar.css("height", navbar.prop("scrollHeight"));
        }, 100)
    });

    $("#language-switcher").find(".dropdown-item").click(function() {
        resetPricePerNight();
    })

    if (typeof lightbox != 'undefined') {
        lightbox.option({
            'resizeDuration': 0,
            'albumLabel': '%1 / %2',
            'fadeDuration': 0,
            'imageFadeDuration': 0,
            'wrapAround': true
        });
    }

    $("#newsletter-form").submit(function (e) {
        e.preventDefault();
        const wrap = $("#newsletter-form-wrap");
        const btn = $("#newsletter-form-submit");

        $.ajax({
            url: "/newsletter/send-verify",
            method: "POST",
            data: {
                email: $("#newsletter-email").val()
            },
            beforeSend: function () {
                btn.attr("disabled", true).css("color", "white");
                btn.prepend('<span class="spinner-border spinner-border-sm text-white" role="status"></span>');
            },
            error: function (error) {
                console.log(error.responseText);
                btn.attr("disabled", false);
                btn.find(".spinner").remove();
            },
            success: function (r) {
                wrap.html(r)
            }
        });
    })

    $(".nav-search-button").click(function (e) {
        let width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        if (width < 992 || width > 1349) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
                setTimeout(function () {
                    $(".header-search-input").focus();
                }, 200);

                $(this).addClass("active");
            }
        }
    });

    $(".header-search-input").click(function(e) {
        e.stopPropagation();
    })

    $(".nav-search-button i").click(function () {
        const parent = $(this).closest(".nav-search-button");
        if (parent.find("input").val().length > 0 && parent.hasClass("active")) {
            parent.find("form").submit();
        }
    });

    $(".number-only-input").on("change", function() {
        let value = $(this).val();
        $(this).val(value.replaceAll(" ", ""));
    })

    //remove slugs from get parameters
    removeParamFromUrl("slug");
    removeParamFromUrl("slugEn");
    removeParamFromUrl("slugDe");
    removeParamFromUrl("slugPl");
    removeParamFromUrl("slugSk");
});

// Close search bar when clicked outside
$(document).click(function (event) {
    if (!$(event.target).closest(".nav-search-button").length) {
        $("body").find(".nav-search-button").removeClass("active");
    }
});

var resizeId;
window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 200);
});

function doneResizing() {
    measureHeader()
}

/*
document.fonts.ready.then(function() {
    // do someting when fonts are loaded completely
    document.querySelectorAll(".fa, .fas, .fab, .fa-wrap").forEach(function(i) {
        i.style.opacity="1"
    })
});*/